<template>

</template>

<script>
    export default {
        name: "industry"
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ganPinMonitoring/industry.vue